import { render, staticRenderFns } from "./IndividualExamScoreOverviewPanel.vue?vue&type=template&id=11fefc2f&scoped=true"
import script from "./IndividualExamScoreOverviewPanel.vue?vue&type=script&lang=js"
export * from "./IndividualExamScoreOverviewPanel.vue?vue&type=script&lang=js"
import style0 from "./IndividualExamScoreOverviewPanel.vue?vue&type=style&index=0&id=11fefc2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fefc2f",
  null
  
)

export default component.exports